const NotFound = () => {
	return <span>Not found</span>;
};
export default NotFound;
